import { DataTable } from "@/core/components/layout/data-table";
import { DashboardFilters } from "@/dashboard/types";
import { useEffect } from "react";
import { useDashboardRankingsCities } from "../../hooks/use-dashboard-rankings-cities";

interface DashboardRankingsCitiesDataTableProps extends React.ComponentPropsWithoutRef<"div"> {
  filters: DashboardFilters;
  setTop3RankingData: (
    data: { position: number; name: string; value: number }[],
  ) => void;
  setIsLoading: (isLoading: boolean) => void;
}

export const DashboardRankingsCitiesDataTable = ({
  filters,
  setTop3RankingData,
  setIsLoading,
  ...props
}: DashboardRankingsCitiesDataTableProps) => {
  const { table, isLoading, top3RankingData } =
    useDashboardRankingsCities(filters);

  useEffect(() => {
    setTop3RankingData(top3RankingData);
    setIsLoading(isLoading);
  }, [top3RankingData, filters]);

  return (
    <div {...props}>
      <DataTable table={table} isLoading={isLoading} withoutPagination={true} />
    </div>
  );
};
